
"use client";

import { useEffect } from 'react';
import { initAnalytics } from '../lib/analytics';

export function AnalyticsMonitor() {
    useEffect(() => {
        initAnalytics();
    }, []);

    return null; // This component doesn't render anything
}
